// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Belt_Array from "../../../../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as NextImage$PorterinFeature from "../../../../ui/components/NextImage.mjs";
import * as FeaturedModuleScss from "../styles/Featured.module.scss";
import * as FeaturedItemCmp$PorterinFeature from "./FeaturedItemCmp.mjs";
import * as NativeCarouselCmp$PorterinFeature from "../../../../shared/carousel/view/components/NativeCarouselCmp.mjs";
import * as FeaturedCarouselIndicatorModuleScss from "../styles/FeaturedCarouselIndicator.module.scss";

var styles = FeaturedModuleScss;

var carousel_indicator_styles = FeaturedCarouselIndicatorModuleScss;

function FeaturedCmp(Props) {
  var news_articles_data = Props.news_articles_data;
  var redirect_icon = Props.redirect_icon;
  var wave_icon = Props.wave_icon;
  var read_article_label = Props.read_article_label;
  var title = Props.title;
  if (title.length !== 0) {
    return React.createElement("div", {
                className: styles.container
              }, React.createElement("div", {
                    className: styles["title-container"]
                  }, React.createElement(NextImage$PorterinFeature.make, {
                        src: wave_icon.path,
                        height: 8.0,
                        width: 50.0,
                        quality: 100.0,
                        alt: wave_icon.alt_text
                      }), React.createElement("h2", {
                        className: styles.title
                      }, title), React.createElement(NextImage$PorterinFeature.make, {
                        src: wave_icon.path,
                        height: 8.0,
                        width: 50.0,
                        quality: 100.0,
                        alt: wave_icon.alt_text
                      })), React.createElement(NativeCarouselCmp$PorterinFeature.make, {
                    class_name: styles["carousel-container"],
                    carousel_indicator_styles: carousel_indicator_styles,
                    carousel_item_wrapper_class: styles["carousel-item"],
                    are_indicators_clickable: true,
                    children: Belt_Array.map(news_articles_data, (function (news_article) {
                            return React.createElement(FeaturedItemCmp$PorterinFeature.make, {
                                        news_article: news_article,
                                        redirect_icon: redirect_icon,
                                        read_article_label: read_article_label,
                                        key: news_article.content
                                      });
                          })),
                    show_indicators: true,
                    delay: 4000,
                    autoplay: true
                  }));
  } else {
    return null;
  }
}

var sectionWaveSvg = "/assets/icons/home/section-header-wave-light.svg";

var make = FeaturedCmp;

export {
  styles ,
  carousel_indicator_styles ,
  sectionWaveSvg ,
  make ,
}
/* styles Not a pure module */
